'use client';

import './index.css';

import classNames from 'classnames';
import { useCopyToClipboard } from 'usehooks-ts';

import { linkResolver } from '@/helpers/storyblok/link-resolver';

export const ShareRessource = ({ title = 'Partager', story }) => {
  const url = `${process.env.ORIGIN}${linkResolver(null, story)}`;

  const [copiedText, copy] = useCopyToClipboard();

  return (
    <div className="share-ressource">
      <div className="share-ressource__title">{title}</div>

      <div className="share-ressource__buttons">
        <a
          className="share-ressource__button"
          href={`https://www.linkedin.com/feed/?shareActive=true&text=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            src="/icons/linkedin-circle.svg"
            width="24"
            height="25"
            alt="Partager sur LinkedIn"
          />
        </a>

        <button
          type="button"
          className={classNames(
            'share-ressource__button',
            'share-ressource__button--copy',
          )}
          onClick={() => {
            copy(url);
          }}
        >
          <img
            src="/icons/copy-grey.svg"
            width="21"
            height="21"
            alt="Copier le lien"
          />
        </button>
      </div>
    </div>
  );
};
